<template>
    <div class="form-box">
        <div class="form-right">
            <div style="width:100%;height:5vh;padding-left:1vw;background:#fff;display:flex;align-items: center;">
                <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
            </div>
            <div style="width:100%;height:calc( 100% - 5vh );position: relative;padding:1vh;background:#fff;overflow: auto;">
                <el-table :data="tableData" border style="width: 100%" :summary-method="getSummaries" show-summary :header-row-class-name="'table-head'">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="序号" width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="time" label="日期">
                        <template slot-scope="scope">
                            <span>{{scope.row.time}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="apprMoney" label="审定产值（万元）">
                        <template slot-scope="scope">
                            <span>{{scope.row.apprMoney}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="payMoney" label="工程款支付（万元）">
                        <template slot-scope="scope">
                            <span>{{scope.row.payMoney}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="baseMoney" v-if="unitKind=='1'" label="农民工专户支付（万元）">
                        <template slot-scope="scope">
                            <p>{{scope.row.baseMoney}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bilv" v-if="unitKind=='1'" label="农民工专户支付比例">
                        <template slot-scope="scope">
                            <span >{{scope.row.bilv}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="damMoney" label="违约金（万元）">
                        <template slot-scope="scope">
                            <span >{{scope.row.damMoney}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="success" @click="infoFun(scope.row)">查看</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            dataTree:[],
            defaultProps: {
                children: 'list',
                label: 'name'
            },
            projectId:'',//当前项目id
            dataText: '数据加载中...',
            tableData:[],
            curId:0,
            pageTitle:'',
            id:'',
            unitKind:'',
            
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        // this.getLeftMenu()
        this.getData()
        this.getInfo()
    },
    methods:{
        //获取侧边树
        // getLeftMenu(){
        //     var that = this
        //     myHttp.getEntProjectList({
        //         groupId: this.groupId,
        //         pageNum:1,
        //         pageSize:10000
        //     }).then(function(resp) {
        //         if (resp.data.code == '200') {
        //             var list = resp.data.data.entProject.list || []
        //             that.dataTree = list
        //             //for(var i=0;i<list.length;i++){
        //             if (list.length > 0 && that.projectId=='') {
        //                 that.projectId= list[0].id
        //                 that.getData()
        //             }
        //             //}
        //         }
        //     })
        // },
        //树形点击
        // handleNodeClick(e,index){
        //     this.projectId = e.id
        //     this.curId = index
        //     this.getData()
            
        // },
        //获取合同信息
        getInfo(){
            var that = this
            myHttp.getContractById({
                id:this.id,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.pageTitle = that.pageTitle && that.pageTitle!=''?data.name+' - '+that.pageTitle:data.name
                    that.unitKind = data.unitKind
                }
            })
        },
        //获取数据
        getData(){
            var that = this
            myHttp.getContractStageByProjectId({
                contractId:this.id,
                status:'3',
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.object
                    if(data){
                        // that.pageTitle = that.pageTitle && that.pageTitle!=''?that.pageTitle+' - '+data.contractName:data.contractName
                        var list = data.first? JSON.parse(data.first).list:[]
                        for(var i=0;i<list.length;i++){
                            list[i].index = i+1
                            list[i].damMoney = list[i].damMoney?list[i].damMoney:0
                            list[i].payMoney = list[i].payMoney?list[i].payMoney:0
                            list[i].baseMoney = list[i].baseMoney?list[i].baseMoney:0
                            list[i].bilv = list[i].payMoney==0&&list[i].damMoney==0?0:(parseFloat(list[i].baseMoney)/(parseFloat(list[i].damMoney)+parseFloat(list[i].payMoney))*100).toFixed(2)+'%'
                        }
                        that.tableData = list
                        if(list.length==0){
                            that.dataText = '暂无数据'
                        }
                    }else{
                        that.dataText = '暂无数据'
                    }
                }
            })
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },

        //
        getSummaries(param){
            // var columns = param.columns
            // var data = param.data
            const { columns, data } = param;
            var baseAll = 0, damAll = 0,payAll=0
            var sums = [];
            for(var i=0;i<data.length;i++){
                baseAll = data[i].baseMoney?parseFloat(data[i].baseMoney)+baseAll:baseAll
                damAll = data[i].damMoney?parseFloat(data[i].damMoney)+damAll:damAll
                payAll = data[i].payMoney?parseFloat(data[i].payMoney)+payAll:payAll
            }
            var bilv = damAll==0&&payAll==0?0:(parseFloat(baseAll)/(parseFloat(damAll)+parseFloat(payAll))*100).toFixed(2)+'%'
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index === 5) {
                    sums[index] = bilv;
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] += '';
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    /* .form-left{
        width:15vw;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        align-items: flex-start;
    }
    .form-left .on{
        color: #2447D7;
    } */
    .form-right{
        width: 100%;
        height: 100%;
        position: relative;
        padding-left: 1vh;
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
    .el-table__footer-wrapper td{
        border-top: 1px solid #303133;
    }
</style>